import { render, staticRenderFns } from "./HousingOptionsComponent.vue?vue&type=template&id=86aac208"
import script from "./HousingOptionsComponent.vue?vue&type=script&lang=js"
export * from "./HousingOptionsComponent.vue?vue&type=script&lang=js"
import style0 from "./HousingOptionsComponent.vue?vue&type=style&index=0&id=86aac208&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports